import { format, isSameDay } from 'date-fns';

// The phone's Mon–Sun strip (GRAVY-10991), from the client app's dashboard
// design: weekday over date, the selected day underlined in green. It picks the
// day the Day view shows; the arrows above it step whole weeks.

type Props = {
  days: Date[];
  selected: Date;
  onSelect: (day: Date) => void;
};

const DayStrip = ({ days, selected, onSelect }: Props) => {
  const today = new Date();
  return (
    <div className="dashv2-daystrip" data-testid="dayStrip">
      {days.map((day) => {
        const isSelected = isSameDay(day, selected);
        return (
          <button
            key={day.toISOString()}
            type="button"
            className={`dashv2-daystrip-day${isSelected ? ' is-selected' : ''}`}
            data-testid={`dayStrip-${format(day, 'yyyy-MM-dd')}`}
            aria-pressed={isSelected}
            aria-current={isSameDay(day, today) ? 'date' : undefined}
            aria-label={format(day, 'EEEE, MMMM d')}
            onClick={() => onSelect(day)}
          >
            <span className="dashv2-daystrip-wd">{format(day, 'EEE')}</span>
            <span className="dashv2-daystrip-num">{format(day, 'd')}</span>
          </button>
        );
      })}
    </div>
  );
};

export default DayStrip;
